<template>
  <div>
    <load-profile />
    <!-- Table Container Card -->
    <b-card>
      <validation-observer
        ref="createForm"
        #default="{ invalid }"
      >
        <!-- form -->
        <n-form-confirmation
          key="createForm"
          :form="$refs.createForm"
          :disabled="invalid || checkUsernameLoading"
          @submit="submit"
        >
          <n-input
            v-model="data"
            :fields="fields"
            :init-value="initData"
          >
            <template #secondUsername="item">
              <b-form-group :label-for="item.field.key">
                <validation-provider
                  #default="{ errors }"
                  :vid="item.field.key"
                  :name="$t(item.field.label)"
                  :rules="item.field.rules"
                >
                  <label>
                    {{ $t(item.field.label) }}
                  </label>
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      v-model="data[item.field.key]"
                      :placeholder="$t(item.field.label)"
                      :name="item.field.key"
                      :disabled="item.field.disabled"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      autocomplete="off"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        icon="RefreshCcwIcon"
                        @click="generateSecondUsername(data.parentId)"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>
            <template #paybackOption="item">
              <b-form-group :label-for="item.field.key">
                <validation-provider
                    #default="{ errors }"
                    :vid="item.field.key"
                    :name="$t(item.field.label)"
                    :rules="item.field.rules"
                >
                  <label>
                    {{ $t(item.field.label) }}
                  </label>
                  <n-single-select
                      v-model="data[item.field.key]"
                      :reduce="true"
                      :options="dropPaybackCommissionPeriod"
                      clearable
                      :class="errors.length > 0 ? 'is-invalid' : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>
            <template #parentId="item">
              <b-form-group :label-for="item.field.key">
                <validation-provider
                  #default="{ errors }"
                  :vid="item.field.key"
                  :name="$t(item.field.label)"
                  :rules="item.field.rules"
                >
                  <label>
                    {{ $t(item.field.label) }}
                  </label>
                  <n-async-single-select
                    v-model="data[item.field.key]"
                    :name="item.field.key"
                    :init-options="data[item.field.key]"
                    :repository="item.field.repository"
                    :selection-key="item.field.selectionKey"
                    :selection-label="item.field.selectionLabel"
                    :readonly="getSuggestionUsernameLoading"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    @optionChange="changeOption"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>
            <template #loginTimeout="item">
              <b-form-group :label-for="item.field.key">
                <validation-provider
                  #default="{ errors }"
                  :vid="item.field.key"
                  :name="$t(item.field.label)"
                  :rules="item.field.rules"
                >
                  <label>
                    {{ $t(item.field.label) }}
                  </label>
                  <n-single-select
                    v-model="data[item.field.key]"
                    :reduce="true"
                    :options="timeout"
                    :clearable="false"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>
            <template #accrueDepositPeriod="item">
              <b-form-group :label-for="item.field.key">
                <validation-provider
                  #default="{ errors }"
                  :vid="item.field.key"
                  :name="$t(item.field.label)"
                  :rules="item.field.rules"
                >
                  <label>
                    {{ $t(item.field.label) }}
                  </label>
                  <n-single-select
                    v-model="data[item.field.key]"
                    :reduce="true"
                    :options="dropCommissionPeriod"
                    clearable
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>
            <template #state="item">
              <b-form-group :label-for="item.field.key">
                <validation-provider
                  #default="{ errors }"
                  :vid="item.field.key"
                  :name="$t(item.field.label)"
                  :rules="item.field.rules"
                >
                  <label>
                    {{ $t(item.field.label) }}
                  </label>
                  <n-single-select
                    v-model="data[item.field.key]"
                    :reduce="true"
                    :options="an"
                    :clearable="false"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>
          </n-input>
          <b-row>
            <b-col
              cols="12"
              class="text-right"
            >
              <n-button-loading
                v-if="$can('create', 'player')"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mt-1 mr-1"
                :loading="loading"
                :disabled="invalid || checkUsernameLoading"
              >
                {{ $t('button.saveChanges') }}
              </n-button-loading>
              <n-button-loading
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                :loading="loading"
                class="mt-1"
                @submit="back"
              >
                {{ $t('button.back') }}
              </n-button-loading>
            </b-col>
          </b-row>
        </n-form-confirmation>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import {
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BRow,
} from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import Ripple from 'vue-ripple-directive'
import NButtonLoading from '@/components/NButtonLoading.vue'
import NFormConfirmation from '@/components/NFormConfirmation.vue'
import NSingleSelect from '@/components/NSingleSelect.vue'
import NInput from '@/components/NInput.vue'
import Alphabet from '@/data/numberAlphabet'
import AN from '@/data/an'
import DropCommissionPeriod from '@/data/dropCommissionPeriod'
import DropPaybackCommissionPeriod from '@/data/dropPaybackCommissionPeriod'
import Timeout from '@/data/timeout'
import NAsyncSingleSelect from '@/components/NAsyncSingleSelect.vue'
import FormInputAN from './formInputAN'
import FormInput from './formInput'

const PlayerRepository = Repository.get('player')

export default {
  components: {
    BInputGroup,
    BInputGroupAppend,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    NButtonLoading,
    NFormConfirmation,
    NInput,
    NSingleSelect,
    NAsyncSingleSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {
        channelIds: [],
        lastName: null,
        phone: null,
        username: null,
        password: null,
        minBetTime: 0,
        maxBetTime: 0,
        maxBetGame: 0,
        maxDrawBetGame: 0,
        maxWinDay: 0,
        maxBetAmountParley: 0,
        minBetTimeBacar: 0,
        maxBetTimeBacar: 0,
        maxBetGameBacar: 0,
        maxBetDrawPerGameBacar: 0,
        maxWinDayBacar: 0,
        ccy: null,
        isEnable: true,
        isReadonly: false,
        secondUsername: '',
      },
      initData: {},
      loading: false,
      checkUsernameLoading: false,
      usernameValid: false,
      getSuggestionUsernameLoading: false,
      username: {
        parent: null,
      },

      an: AN,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile.name
        ? this.$store.state.profile
        : JSON.parse(localStorage.getItem('userData'))
    },
    isCanGenerateSecondUsername() {
      return this.$can('update', 'bet-setting') || this.userData.isGenSecondUsername
    },
    isCanSetPaybackCommission() {
      return this.$can('update', 'bet-setting') || this.userData.allowPaybackCommission
    },
    fields() {
      if (this.userData.searchState) {
        return FormInputAN.map(value => {
          if (value.key === 'password' || value.key === 'retypePassword') {
            value.rules = value.rules.replace('required|', '')
            value.rules = value.rules.replace('required', '')
            value.rules = value.rules.replace('', 'required|')
          } else if (value.key === 'username') {
            value.disabled = false
          } else if (value.key === 'secondUsername') {
            value.hide = !this.isCanGenerateSecondUsername
          } else if (['commissionPayback'].includes(value.key)) {
            value.hide = !this.isCanSetPaybackCommission
          }

          return value
        })
      }

      return FormInput.map(value => {
        if (value.key === 'password' || value.key === 'retypePassword') {
          value.rules = value.rules.replace('required|', '')
          value.rules = value.rules.replace('required', '')
          value.rules = value.rules.replace('', 'required|')
        } else if (value.key === 'username') {
          value.disabled = false
        } else if (value.key === 'secondUsername') {
          value.hide = !this.isCanGenerateSecondUsername
        } else if (['commissionPayback'].includes(value.key)) {
          value.hide = !this.isCanSetPaybackCommission
        }

        return value
      })
    },
  },
  watch: {
    'data.parentId': function (value) {
      this.getSuggestUsername(value)
    },
    'data.username': function (value) {
      if (value) {
        this.checkUsername(`${this.username.parent}${value}`)
      }
    },
  },
  beforeMount() {
    if (this.userData.isVendor) {
      this.$router.push({ name: 'not-authorized' })
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.show()
    }
  },
  methods: {
    changeOption(value) {
      this.username.parent = value?.username
    },
    show() {
      PlayerRepository.show(this.$route.query.id)
        .then(response => {
          this.initData = {
            ...response.data.data,
            phone: null,
            username: null,
            secondUsername: null,
          }
        })
    },
    submit() {
      if (!this.usernameValid) {
        return
      }
      this.$refs.createForm.validate()
        .then(success => {
          if (success) {
            this.loading = true
            const data = {
              ...this.data,
              username: `${this.username.parent}${this.data.username}`,
            }
            PlayerRepository.create(data)
              .then(response => {
                this.$router.push({
                  name: 'view-player',
                  params: { id: response.data.data.id },
                })
              })
              .catch(error => {
                if (error.response?.status === 422) {
                  this.$refs.createForm.setErrors(error.response?.data?.errors)
                }
              })
              .then(() => {
                this.loading = false
              })
          }
        })
    },
    getSuggestUsername(parentId) {
      this.checkUsernameLoading = true
      this.getSuggestionUsernameLoading = true
      PlayerRepository.getSuggestUsername(parentId)
        .then(response => {
          const data = response.data?.data
          const { username } = data
          this.data.username = username.replace(data.parentUsername, '')
          this.usernameValid = true
        })
        .catch()
        .then(() => {
          this.checkUsernameLoading = false
          this.getSuggestionUsernameLoading = false
        })

      this.generateSecondUsername(parentId)
    },
    checkUsername(username) {
      if (this.getSuggestionUsernameLoading) {
        return
      }

      this.checkUsernameLoading = true
      PlayerRepository.checkUsername(username)
        .then(response => {
          if (response.data?.data.used) {
            this.$refs.createForm.setErrors({
              username: this.$t('validation.unique', {
                field: this.$t('field.username'),
              }),
            })
            this.usernameValid = false
          } else {
            this.usernameValid = true
          }
        })
        .catch()
        .then(() => {
          this.checkUsernameLoading = false
        })
    },
    generateSecondUsername(parentId) {
      if (this.isCanGenerateSecondUsername && parentId) {
        PlayerRepository.generateSecondUsername(parentId)
          .then(response => {
            this.data.secondUsername = response.data?.data?.secondUsername
          })
          .catch()
      }
    },
    back() {
      this.$router.back()
    },
  },
  setup() {
    const alphabet = [...Alphabet]
    const timeout = [...Timeout]
    const dropCommissionPeriod = [...DropCommissionPeriod]
    const dropPaybackCommissionPeriod = [...DropPaybackCommissionPeriod]
    return {
      alphabet,
      timeout,
      dropCommissionPeriod,
      dropPaybackCommissionPeriod,
    }
  },
}
</script>
